import { render, staticRenderFns } from "./AllocationDoughnut.vue?vue&type=template&id=2adaaca3&lang=pug"
import script from "./AllocationDoughnut.vue?vue&type=script&lang=js"
export * from "./AllocationDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports